import { render, staticRenderFns } from "./PostPayment.vue?vue&type=template&id=5029e85e&"
import script from "./PostPayment.vue?vue&type=script&lang=js&"
export * from "./PostPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports